
export const openPopup = (url: string): void => {
  window.open(url, 'popup', `width=${window.screen.width * 0.3},height=${window.screen.height}`)
}
